import React, { useEffect, useState } from 'react';
import { getClientId } from '../../utils/clientId';
import { getPollStatus } from '../../utils/pollApi';
import BorgoPollDialog from './BorgoPollDialog';

/* Mounted once in the public Layout. Auto-opens the vote dialog once per
   festival day until this device has voted that day; dismissing it
   silences the prompt until the next day. The dialog stays reachable
   any time from the "Borgo più amato" page. */

const PROMPT_KEY = 'palio_poll_prompted_day';

// Mirrors the server's festival-day cutoff (05:00 Europe/Rome) closely
// enough to throttle the prompt; voting itself is gated server-side.
const promptDay = () => new Date(Date.now() - 5 * 3_600_000).toDateString();

const BorgoPollPrompt: React.FC = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(PROMPT_KEY) === promptDay()) return;
    let alive = true;
    (async () => {
      try {
        const status = await getPollStatus(getClientId());
        if (alive && !status.voted_today && !status.closed) {
          localStorage.setItem(PROMPT_KEY, promptDay());
          setOpen(true);
        }
      } catch {
        /* backend unreachable / poll off: stay silent, never block the app */
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  return <BorgoPollDialog open={open} onClose={() => setOpen(false)} />;
};

export default BorgoPollPrompt;
